import { ClaimModal } from "@customer-gallery/components/GalleryPageCmp/ClaimModal";
import { GalleryListCmp } from "@customer-gallery/components/GalleryPageCmp/GalleryList";
import { CustomerTypedRoute } from "@customer-gallery/definitions/routeDefinitions";
import { loadDiscounts } from "@customer-gallery/redux/actionCreators/discounts";
import { useNovelCustomerDispatch, useNovelCustomerSelector } from "@customer-gallery/redux/reduxHooks";
import { ITokenCollectionClaimWithTokenCollection } from "@novel/shared/interfaces/TokenCollectionClaim";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CustomizeGalleryPolaris } from "@customer-gallery/components/CustomerPortalLayout/CustomizeGalleryPolaris";
import { claimTokenLineItem } from "@customer-gallery/redux/actionCreators/unclaimedTokens";
import { useAsyncCallback } from "@novel/shared/utils/useAsyncCallback";
import { useOnlyWalletAndEvmAddress } from "@customer-gallery/redux/reducers/cryptoAddresses";
import { GalleryAuthWallet } from "@customer-gallery/utils/galleryWallets";
export const GalleryPageCmp: CustomerTypedRoute<"/"> = function GalleryPageCmp({
  props
}) {
  const cryptoAddresses = useNovelCustomerSelector(state => state.addresses?.cryptoAddresses);
  const usersOnlyWalletAndEvmAddress = useOnlyWalletAndEvmAddress();
  const unclaimedTokens = useNovelCustomerSelector(state => state.unclaimedTokens?.unclaimedTokens);
  const [setting, setSetting] = useState(false);
  const isClaimingToken = useNovelCustomerSelector(state => state.unclaimedTokens?.isClaimingToken);
  const discounts = useNovelCustomerSelector(state => state.discounts?.totalCustomerDiscounts);
  const user = useNovelCustomerSelector(state => state.auth.user);
  const dispatch = useNovelCustomerDispatch();
  const [search, setSearch] = useState<null | string>();
  const [claimingToken, setClaimingToken] = useState<null | ITokenCollectionClaimWithTokenCollection>();
  const closeClaimModal = useCallback(() => setClaimingToken(null), []);
  const disableClaimButtonWhileClaiming = useMemo(() => !!isClaimingToken && !!usersOnlyWalletAndEvmAddress, [isClaimingToken, usersOnlyWalletAndEvmAddress]);
  const onClickUnclaimed = useAsyncCallback(async (unclaimedTokenLineItem: ITokenCollectionClaimWithTokenCollection) => {
    if (usersOnlyWalletAndEvmAddress) {
      if (unclaimedTokenLineItem.collectionToMintFrom.collectionMetadata.decentralizedMintEnabled) {
        await new GalleryAuthWallet(usersOnlyWalletAndEvmAddress.cryptoWallet).ensureWalletAppInstalled(async () => {
          await dispatch(claimTokenLineItem(usersOnlyWalletAndEvmAddress.cryptoAddress, usersOnlyWalletAndEvmAddress.cryptoWallet, unclaimedTokenLineItem));
        });
      } else {
        await dispatch(claimTokenLineItem(usersOnlyWalletAndEvmAddress.cryptoAddress, usersOnlyWalletAndEvmAddress.cryptoWallet, unclaimedTokenLineItem));
      }
    } else {
      setClaimingToken(unclaimedTokenLineItem);
    }
  }, [dispatch, usersOnlyWalletAndEvmAddress]);
  const onNavigationToggle = useCallback(() => {
    dispatch({
      type: "CHANGE_SIDEBAR_STATUS",
      payload: {
        open: true
      }
    });
  }, [dispatch]);
  const handleChange = (e: any) => {
    setSearch(e.target.value);
  };
  const handleSetting = (state: boolean) => {
    setSetting(state);
  };

  // Derives discounts from Shopify based on customers NFTs and Org Token Relationships
  useEffect(() => {
    if (user && user.isSuperUser) {
      dispatch(loadDiscounts());
    }
  }, [dispatch, user]);
  return <React.Fragment>
            <CustomizeGalleryPolaris setSetting={handleSetting} settingState={setting} handleSearchChange={handleChange} onClickHandler={onNavigationToggle} primaryAction>
                <GalleryListCmp search={search} discounts={discounts} settingState={setting} filterToAddress={props.address} filterToContract={props.collection} addresses={cryptoAddresses} unclaimedTokens={unclaimedTokens} onClickUnclaimed={onClickUnclaimed} disableClaimButtonWhileClaiming={disableClaimButtonWhileClaiming} isClaimingToken={isClaimingToken} />
            </CustomizeGalleryPolaris>
            {claimingToken && <ClaimModal claimingTokenLineItem={claimingToken} onClose={closeClaimModal} />}
            <style global jsx>{`
                .manage-wallets-key-icon {
                    transform: scale(0.85) translateY(-0.5px) translateX(-0.5px);
                }
                .copy-clipboard {
                    cursor: pointer;
                }
            `}</style>
        </React.Fragment>;
};